// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3yIYo","content":"GlobalSearch_content__1IemC"};